// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2029) return "static/chunks/2029-6d0ef70c38e2fcf5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2840":"3d12a5b3c992b53f","8218":"6d991407adbaf930"}[chunkId] + ".js";
};